// All backend calls used by the Kursy module, in one place - mirrors the
// shape of exercise-templates/api.js. Generic CRUD is parameterized by
// apiBase since every courses-hierarchy endpoint (+ TopicElement +
// TopicExerciseTemplate) shares an identical GET-list/GET-one/POST/PUT/
// DELETE shape.

import axios from 'axios';

const jsonHeaders = {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
};

export function getList(apiBase, filterParam, parentId) {
    const url = filterParam && parentId != null ? apiBase + '?' + filterParam + '=' + parentId : apiBase;
    return axios.get(url, { withCredentials: true });
}

export function getOne(apiBase, id) {
    return axios.get(apiBase + '/' + id, { withCredentials: true });
}

export function createOne(apiBase, payload) {
    return axios.post(apiBase, JSON.stringify(payload), jsonHeaders);
}

export function updateOne(apiBase, id, payload) {
    return axios.put(apiBase + '/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteOne(apiBase, id) {
    return axios.delete(apiBase + '/' + id, jsonHeaders);
}

// Used by both Index.jsx's Course delete and useCourseWorkspace's node
// delete - one implementation of the "does this still have children" guard,
// needed because none of the courses-hierarchy tables cascade-delete on the
// backend (every child is a NOT NULL FK with no parent-side @OneToMany).
export function hasChildren(childCheck, parentId) {
    return getList(childCheck.apiBase, childCheck.filterParam, parentId)
        .then((response) => Array.isArray(response.data) && response.data.length > 0);
}

// --- TopicExerciseTemplate: filter param is "exercise" even though the
// body/relation field is "exerciseTemplate" - confirmed against
// TopicExerciseTemplateController, same inconsistency already documented in
// exercise-templates/api.js for a different pair of fields. ---

export function getTopicExerciseTemplates(topicId) {
    return axios.get('/api/topicexercisetemplates?topic=' + topicId, { withCredentials: true });
}

// --- read-only lookup for the "attach existing exercise template" picker ---

export function getExerciseTemplates() {
    return axios.get('/api/exercisetemplates', { withCredentials: true });
}

// --- course workspace header: students modal + delete modal ---

export function getCourseStudents(courseId) {
    return axios.get('/api/courses/' + courseId + '/students', { withCredentials: true });
}

export function getCourseDependencies(courseId) {
    return axios.get('/api/courses/' + courseId + '/dependencies', { withCredentials: true });
}

// dryRun = true runs the server-side validation only; nothing is removed.
export function deleteCourseDependencies(courseId, keys, dryRun) {
    return axios.post('/api/courses/' + courseId + '/dependencies/delete',
        JSON.stringify({ keys: keys, dryRun: !!dryRun }), jsonHeaders);
}
